<div class="block padding-horizontal">
  <header class="toolbars">
    <div class="breadcrumbs">
      <a (click)="goBack()">
        <mat-icon [inline]="true">arrow_back</mat-icon>
        {{ 'BACK' | translate }}
      </a>
    </div>
    <div class="toolbar">
      <h2>
        {{ session?.PointName }}
      </h2>

      <div class="toolbar-actions">
        <button
          mat-icon-button
          class="toolbar-button"
          [disabled]="refreshing"
          matTooltip="{{ 'REFRESH' | translate }}"
          (click)="fetchSessionAndOrder(true)">
          @if (refreshing) {
            <mat-spinner class="button-spinner"></mat-spinner>
          } @else {
            <mat-icon>refresh</mat-icon>
          }
        </button>
      </div>
    </div>
  </header>
</div>

<div class="container-fluid-2">
  <div class="row">
    <div class="col-lg-7">
      <mat-card class="pane">
        <mat-card-content class="!py-8">
          @if (loadingDatas) {
            <mat-spinner class="spinner-center !my-4"></mat-spinner>
          } @else {
            @if (graphData.noData) {
              <div class="txt-center !my-4">
                {{ 'SINGLE_SESSION_TEXT_110' | translate }}
              </div>
            } @else {
              <div class="txt-center charts">
                <mat-radio-group (change)="graphChange($event)">
                  <mat-radio-button [checked]="defaultSessionGraphUnit === GraphType.KW" [value]="GraphType.KW">
                    {{ 'KW' | translate }}
                  </mat-radio-button>
                  <mat-radio-button [checked]="defaultSessionGraphUnit === GraphType.Amps" [value]="GraphType.Amps">
                    {{ 'AMPERE' | translate }}
                  </mat-radio-button>
                  <mat-radio-button [checked]="defaultSessionGraphUnit === GraphType.KWH" [value]="GraphType.KWH">
                    {{ 'KWH' | translate }}
                  </mat-radio-button>
                  @if (graphData?.SoC?.points?.length) {
                    <mat-radio-button [checked]="defaultSessionGraphUnit === GraphType.SoC" [value]="GraphType.SoC">
                      {{ 'BATTERY_PERCENT' | translate }}
                    </mat-radio-button>
                  }
                  @if (hasPricingDetails) {
                    <mat-radio-button
                      *canSee="userType.Support"
                      [checked]="defaultSessionGraphUnit === GraphType.DETAILS"
                      [disabled]="sessionOrderItems.length === 0"
                      [value]="GraphType.DETAILS">
                      {{ 'PRICING_DETAILS' | translate }}
                    </mat-radio-button>
                  }
                </mat-radio-group>
              </div>

              <div>
                <div class="inline-flex w-full justify-center">
                  <div class="w-full" style="position: relative; height: 400px; width: 100%">
                    <canvas #sessionGraph></canvas>
                  </div>
                </div>
              </div>
            }
          }
        </mat-card-content>
      </mat-card>

      <mat-card class="pane">
        <mat-card-header>
          <mat-card-title>{{ 'LOGS' | translate }}</mat-card-title>
        </mat-card-header>
        <mat-card-content class="mat-card-content-table">
          <sc-action-history-table
            [actions]="actions"
            [tableOptions]="tableOptions"
            [loading]="loading"
            [showPoint]="false"
            [showCustomer]="false"
            [refreshing]="refreshing"
            (page)="onPage($event)"></sc-action-history-table>
        </mat-card-content>
      </mat-card>
    </div>

    <div class="col-lg-5">
      <mat-card class="pane">
        <mat-card-header>
          <mat-card-title>{{ 'SESSION_DETAILS' | translate }}</mat-card-title>

          <div class="mat-card-header-actions">
            @if (session?.IsOfflineSession) {
              <mat-icon class="txt-gray mx-2" matTooltip="{{ 'OFFLINE_SESSION' | translate }}"> cloud_off </mat-icon>
            }
            @if (session?.HasWarningsOrErrors) {
              <mat-icon class="txt-warn mx-2" matTooltip="{{ 'SESSION_HAS_WARNINGS' | translate }}"> warning </mat-icon>
            }
            @switch (session?.StartMethod) {
              @case ('SMS') {
                <mat-icon class="txt-gray mx-2" matTooltip="{{ 'STARTED_WITH_SMS' | translate }}">sms</mat-icon>
              }
              @case ('RFID') {
                <mat-icon class="txt-gray mx-2" matTooltip="{{ 'STARTED_WITH_RFID' | translate }}">
                  settings_remote
                </mat-icon>
              }
              @case ('QR') {
                <mat-icon class="txt-gray mx-2" matTooltip="{{ 'STARTED_WITH_QR' | translate }}">
                  border_outer
                </mat-icon>
              }
              @case ('App') {
                <mat-icon class="txt-gray mx-2" matTooltip="{{ 'STARTED_WITH_APP' | translate }}">
                  phone_iphone
                </mat-icon>
              }
              @case ('ROAMING_REMOTE_START') {
                <mat-icon class="txt-gray mx-2" matTooltip="{{ 'STARTED_WITH_ROAMING_EMSP' | translate }}">
                  phone_iphone
                </mat-icon>
              }
              @case ('ROAMING_LOCAL_START') {
                <mat-icon class="txt-gray mx-2" matTooltip="{{ 'STARTED_WITH_ROAMING_TAG' | translate }}">
                  settings_remote
                </mat-icon>
              }
              @case ('Dashboard') {
                <mat-icon class="txt-gray mx-2" matTooltip="{{ 'STARTED_FROM_DASHBOARD' | translate }}"> tv </mat-icon>
              }
              @case ('PLUG_AND_CHARGE') {
                <mat-icon class="txt-gray mx-2" matTooltip="{{ 'STARTED_AUTOMATICALLY' | translate }}">
                  power
                </mat-icon>
              }
              @case ('PAYMENT_TERMINAL') {
                <mat-icon class="txt-gray mx-2" matTooltip="{{ 'PAYMENT_TERMINAL' | translate }}">
                  point_of_sale
                </mat-icon>
              }
              @default {
                <mat-icon class="txt-gray mx-2" matTooltip="{{ 'UNKNOWN_START_METHOD' | translate }}"> power </mat-icon>
              }
            }
          </div>
        </mat-card-header>

        <mat-card-content>
          @if (!loadingDatas) {
            <div class="flex">
              <mat-list>
                <mat-list-item>
                  <mat-icon matListItemIcon>timer</mat-icon>
                  <span matListItemTitle>{{ 'STARTED' | translate }}</span>
                  <span matListItemLine>{{ session?.SessionStart | cDate: 'L LT' }}</span>
                </mat-list-item>
                <mat-list-item>
                  <mat-icon matListItemIcon>history</mat-icon>
                  <span matListItemTitle>{{ 'ENDED' | translate }}</span>
                  <span matListItemLine>{{ session?.SessionEnd | cDate: 'L LT' }}</span>
                </mat-list-item>
                <mat-list-item>
                  <mat-icon matListItemIcon>schedule</mat-icon>
                  <span matListItemTitle>{{ 'DURATION' | translate }}</span>
                  <span matListItemLine>{{ session?.Duration | convertSeconds }}</span>
                </mat-list-item>
              </mat-list>
              <mat-list>
                <mat-list-item>
                  <mat-icon matListItemIcon>speed</mat-icon>
                  <span matListItemTitle>{{ 'ENERGY_CONSUMED' | translate }}</span>
                  <span matListItemLine>{{ session?.TotalkWh | number: '1.2-2' }} {{ 'KWH' | translate }}</span>
                </mat-list-item>
                <mat-list-item>
                  <mat-icon matListItemIcon>stop_circle</mat-icon>
                  <span matListItemTitle>{{ 'STOP_REASON' | translate }}</span>
                  <span matListItemLine>{{ session?.StopReason }}</span>
                </mat-list-item>
                @if (showPaymentStatus) {
                  <mat-list-item>
                    <mat-icon matListItemIcon>paid</mat-icon>
                    <span matListItemTitle>{{ 'PAYMENT_STATUS' | translate }}</span>
                    <span matListItemLine>{{ paymentStatus }}</span>
                  </mat-list-item>
                }
              </mat-list>
            </div>
          }
          @if (loadingDatas) {
            <mat-spinner class="spinner-center"></mat-spinner>
          }
        </mat-card-content>
      </mat-card>

      <mat-card class="pane">
        <mat-card-header>
          <mat-card-title>{{ 'OTHER_INFORMATIONS' | translate }}</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          @if (!loadingDatas) {
            <div class="flex">
              <mat-list>
                <mat-list-item>
                  @if (order.CustomerNote === 'Adhoc') {
                    <mat-icon matListItemIcon matTooltip="{{ 'ADHOC_USER' | translate }}">record_voice_over</mat-icon>
                  } @else {
                    <mat-icon matListItemIcon>person</mat-icon>
                  }
                  <span matListItemTitle>{{ 'USER' | translate }}</span>
                  <span matListItemLine>
                    @if (session?.FK_CustomerID !== 158) {
                      <span *canNotSee="userType.Support">
                        {{ displayName(session) }}
                      </span>
                      <a *canSee="userType.Support" routerLink="/users/{{ session?.FK_CustomerID }}">
                        {{ displayName(session) }}
                      </a>
                    } @else if (session?.FK_CustomerID === 158) {
                      {{ 'UNAUTHENTICATED_CUSTOMER' | translate }}
                    }
                  </span>
                </mat-list-item>
                <mat-list-item>
                  <mat-icon matListItemIcon>place</mat-icon>
                  <span matListItemTitle>{{ 'LOCATION' | translate }}</span>
                  <span matListItemLine>
                    <a routerLink="/station/{{ order?.StationID }}">
                      {{ order?.StationName }}
                    </a>
                  </span>
                </mat-list-item>
                <mat-list-item>
                  <mat-icon matListItemIcon>power</mat-icon>
                  <span matListItemTitle>{{ 'POINT' | translate }}</span>
                  <span matListItemLine>
                    <a routerLink="/station/{{ order?.StationID }}/point/{{ order?.ChargePointID }}/sessions">
                      {{ order?.ChargePointName }}
                    </a>
                  </span>
                </mat-list-item>
              </mat-list>
              <mat-list>
                @if (order.CustomerNote === 'Roaming') {
                  <mat-list-item>
                    <img matListItemIcon [src]="roamingPlatformByID[order.CustomerRoamingPlatformID]?.UrlIcon" />
                    <span matListItemTitle>
                      {{
                        'ROAMING_WITH_PLATFORM'
                          | translate
                            : {
                                platform: roamingPlatformByID[order.CustomerRoamingPlatformID]?.Name || ''
                              }
                      }}
                    </span>
                  </mat-list-item>
                }
              </mat-list>

              <div>
                <div class="absolute right-4 top-4 h-auto w-14 rounded-md text-right md:w-28">
                  @if (chargingBoxModel?.PathImage) {
                    <img
                      class="h-full w-full object-cover"
                      [src]="$safeNavigationMigration(chargingBoxModel?.PathImage)" />
                  }
                  <p class="font-semibold text-center ng-star-inserted">
                    {{ chargingBoxModel?.Name }}
                  </p>
                </div>
              </div>
            </div>
          }
          @if (loadingDatas) {
            <mat-spinner class="spinner-center"></mat-spinner>
          }
        </mat-card-content>
      </mat-card>
    </div>
  </div>
</div>
